import { render, staticRenderFns } from "./TheHeaderAdmin.vue?vue&type=template&id=4795157c"
import script from "./TheHeaderAdmin.vue?vue&type=script&lang=js"
export * from "./TheHeaderAdmin.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderAdmin.vue?vue&type=style&index=0&id=4795157c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports